<template>
	<div class="search-container">
		<input
			v-model="searchTerm"
			autocomplete="off"
			class="search-input"
			data-test="search-input"
			type="search"
			:aria-label="ariaLabel"
			:placeholder="placeholder"
			@input="handleChange"
		/>
		<font-awesome-icon :icon="['far', 'search']" class="search-icon" />
	</div>
</template>

<script>
import { debounce } from 'lodash';

export default {
	name: 'DebouncedSearchInput',
	props: {
		placeholder: String,
		ariaLabel: String,
		value: String,
		onInit: Boolean,
		cancelSearch: Boolean,
	},
	data() {
		return {
			searchTerm: null,
		};
	},
	methods: {
		handleChange: debounce(function () {
			this.$emit('onSearchInputChange', this.searchTerm);
		}, 500),
	},
	watch: {
		onInit(value) {
			if (value) {
				this.searchTerm = '';
			}
		},
		cancelSearch(value) {
			if (value) {
				this.searchTerm = this.value;
				this.$emit('onCancelSearch');
			}
		},
	},
	mounted() {
		this.searchTerm = this.value;
	},
};
</script>

<style lang="scss" scoped>
.search-container {
	position: relative;

	.search-input {
		box-sizing: border-box;
		width: 100%;
		border-radius: 6px;
		border: 1px solid $border-color-light;
		@include rem('font-size', 16px);
		@include rem('padding', 12px 0 12px 36px);
	}

	.search-icon {
		position: absolute;
		@include rem('font-size', 18px);
		color: $brand-blue;
		left: 12px;
		top: 12px;
	}
}
</style>
